import { render, staticRenderFns } from "./ValidacaoCertificado.vue?vue&type=template&id=50ca37cc"
import script from "./ValidacaoCertificado.vue?vue&type=script&lang=js"
export * from "./ValidacaoCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports